import { ChangeDetectorRef, Component } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams, Platform } from 'ionic-angular';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { InfoModalPage } from "../info-modal/info-modal";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { XpReportService } from "../../services/xp-report.service";
import { BarcodeScannerService } from "../../services/barcode-scanner.service";
import { Camera } from "@ionic-native/camera";
import { ViewPhotoPage } from "../view-photo/view-photo";
import {TranslateService} from "@ngx-translate/core";
import { GymDataService } from "../../services/gym-data.service";
import { Storage } from "@ionic/storage";

@Component({
  selector: 'page-xp-report-measurement',
  templateUrl: 'xp-report-measurement.html',
  providers: [GymDataService],
})
export class XpReportMeasurementPage {

  // Workout dropdown data (sourced from the shared GymDataService).
  gymMachines = [];
  momentOptions: Array<string> = ['Calentamiento', 'Serie efectiva', 'Al fallo', 'Back-off'];
  rpeScale = [];
  setNumbers = [];
  gymZones: Array<string> = ['Sala de pesas', 'Maquinas', 'Peso libre', 'Funcional', 'Cardio'];
  seriesTypeOptions: Array<string> = ['Serie normal', 'Serie de calentamiento'];
  exerciseNames: Array<string> = [];
  accessoryNames: Array<string> = ['Mancuernas', 'Banda elastica', 'Agarre cerrado', 'Agarre abierto', 'Cinturon', 'Munequeras', 'Straps', 'Ninguno'];

  // Rep counter (type-102). Reps live inside the per-report FormGroup
  // (forms[i].get('reps')) so saveFormsToReports() ships them automatically.
  // Page-scoped state was removed; handlers below take the report index
  // and mutate the matching FormControl. Pulse-flash is tracked per index.
  // Clamped to 0..9999 (defense-in-depth; see CLAUDE.md rep entry contract).
  bumpReps: { [index: number]: boolean } = {};
  // True while the typed-entry input for that index has focus. Bound by
  // the template to [attr.aria-live] on the big counter so per-keystroke
  // AT chatter is suppressed during typing (the input echoes keystrokes
  // itself). All non-typing mutations still announce via aria-live="polite".
  repFocused: { [index: number]: boolean } = {};

  data: any;
  submitAttempt = false;
  enabled = false;
  hasProSubscription = false;
  required = false;
  isIOS = false;
  devices = [];
  selectedDevice: any;
  showFooter = false;

  reports = [];
  forms: Array<FormGroup> = [];
  unitType = 1;
  workorderType = 1;
  unitExhaustType = '';
  unitFuelType = '';
  unitFuelTypeOil = false;
  unitUnitType = '';
  selectedUnit = null;
  country = 'NL';
  allowRemoveType102 = true;

  dummyData = {
    "_expanded":true,
    "moment_of_measurement":"Voor het onderhoud",
    "co_ppm":12,
    "co_mg_kwh":18,
    "co2_percent":8.4,
    "o2_percent":5.9,
    "o2_intake_percent":"",
    "co_intake_percent":"",
    "co2_intake_percent":"",
    "t_flue_deg_c":44.1,
    "t_air_deg_c":19.3,
    "t_delta_deg_c":11,
    "efficiency_hi_percent":108.2,
    "efficiency_hs_percent":98.4,
    "p_chimney_mbar":12,
    "p_stat_mbar":21.3,
    "p_pump_bar":12,
    "p_firebox_pa":"",
    "p_dyn_mbar":20.2,
    "p_burn_mbar":"",
    "p_control_mbar":"",
    "smoke_index_bacharach":0,
    "lambda":1.39,
    "t_unit_deg_c":70,
    "mains_voltage":"",
    "warmwater_flow_rate":"",
    "gas_usage_full_load":"",
    "contamination":"",
    "fan_voltage":"",
    "device_id":"555",
    "device_sn":"555124766",
    "device_type":"XPRNZ Meettoestel",
    "device_last_service_date":"30-12-2023",
    "reason_first_report_not_possible":"",
    "under_pressure_checked":"",
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public superTabsCtrl: SuperTabsController,
    public reportService: XpReportService,
    public barcodeScanner: BarcodeScannerService,
    public changeDetector: ChangeDetectorRef,
    public camera: Camera,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public platform: Platform,
    public gymData: GymDataService,
    public storage: Storage
  ) {
    // Wire every dropdown to the shared workout data model.
    this.gymMachines = this.gymData.machines();
    this.rpeScale = this.gymData.rpe();
    this.setNumbers = this.gymData.setNumbers();
    this.exerciseNames = this.gymData.exerciseNames();
    if(this.platform.is('ios')){
      this.isIOS = true;
    }
    this.initForm();
  }

  initForm(){
    this.bumpReps = {};
    this.data = this.reportService.getData();
    if(!this.data.reports) this.data.reports = [];
    this.reports = this.data.reports;
    this.enabled = false;
    this.unitExhaustType = '';
    this.unitFuelType = '';
    this.workorderType = parseInt(this.data.workorder_type);
    if (this.data.customers.client && this.data.customers.client.country) {
      this.country = this.data.customers.client.country;
    }
    if(this.data._selected_units && this.data._selected_units[0]) {
      this.selectedUnit = this.data._selected_units[0];
      this.unitType = parseInt(this.data._selected_units[0].unit_model_unit_type);
      // Set unitExhaustType
      let exhaustType = (this.data._selected_units[0].exhaust_type ? this.data._selected_units[0].exhaust_type : '');
      if(exhaustType.search('type A') >= 0){
        this.unitExhaustType = 'A';
      }
      if(exhaustType.search('type B') >= 0){
        this.unitExhaustType = 'B';
      }
      if(exhaustType.search('type C') >= 0){
        this.unitExhaustType = 'C';
      }
      // Set unitFuelType
      this.unitFuelType = (this.data._selected_units[0].fuel_type ? this.data._selected_units[0].fuel_type : '');
      this.unitFuelTypeOil = (this.unitFuelType == 'Stookolie / Mazout');
      // Set unitUnitType
      this.unitUnitType = (this.data._selected_units[0].unit_type ? this.data._selected_units[0].unit_type : '');
      // Set enabled
      this.enabled = true;
    }
    // Set hasProSubscription
    this.hasProSubscription = true;
    // Set default reports
    if(this.enabled && this.hasProSubscription && this.reports.length == 0) {
      if (this.selectedUnit && this.selectedUnit.latest_reports && this.selectedUnit.latest_reports.length) {
        // Load predefined reports from unit
        this.reports = [];
        for (let r of this.selectedUnit.latest_reports) {
          let report = Object.assign({}, r);
          this.reports.push(report);
        }
      } else {
        // Set new default reports
        switch (this.unitType) {
          // CV
          case 1:
            // Add rookgasmeting
            if(this.workorderType == 7){
              this.reports.push({
                type: 103
              });
            } else {
              this.reports.push({
                type: 100
              });
            }
            break;
          // Ventilatie
          case 2:
            // Add ventilatie instellingen
            this.reports.push({
              type: 200
            });
            break;
          // Waterontharder
          case 3:
            // Add waterontharder meting
            this.reports.push({
              type: 301
            });
            break;
          // Hijstoestel
          case 4:
            // Add hijstoestel meting
            this.reports.push({
              type: 401
            });
            break;
          // Airco
          case 5:
            // Add airco meting
            this.reports.push({
              type: 501
            });
            break;
          // Gasleiding
          case 7:
            // Add gasdrukmeting
            this.reports.push({
              type: 701
            });
            break;
          // Gas- of sfeerhaard
          case 9:
            // Add gasdrukmeting
            this.reports.push({
              type: 901
            });
            break;
          case 10:
            // Add grasmaaier meting
            this.reports.push({
              type: 1001
            });
            break;
        }
      }
    }
    // Add photos array to reports
    for(let report of this.reports) {
      switch(report.type) {
        case 201:
        case 202:
        case 203:
          if(report.photos == null){
            report.photos = [];
          }
          break;
      }
    }
    // Build forms
    this.sortReports();
    this.forms = [];
    for(let report of this.reports) {
      let form = null;
      switch(report.type) {
        case 101:
          // Rookgasmeting kort (type = 101)
          form = this.formBuilder.group({
            _expanded: [(report._expanded ? report._expanded : false)],
            moment_of_measurement: [(report.moment_of_measurement ? report.moment_of_measurement : '')],
            co_ppm: [(report.co_ppm ? report.co_ppm : ''), Validators.required],
            co_mg_kwh: [(report.co_mg_kwh ? report.co_mg_kwh : '')],
            co2_percent: [(report.co2_percent ? report.co2_percent : ''), Validators.required],
            o2_percent: [(report.o2_percent ? report.o2_percent : ''), Validators.required],
            t_flue_deg_c: [(report.t_flue_deg_c ? report.t_flue_deg_c : ''), Validators.required],
            t_air_deg_c: [(report.t_air_deg_c ? report.t_air_deg_c : ''), Validators.required],
            t_delta_deg_c: [(report.t_delta_deg_c ? report.t_delta_deg_c : '')],
            efficiency_hi_percent: [(report.efficiency_hi_percent ? report.efficiency_hi_percent : '')],
            efficiency_hs_percent: [(report.efficiency_hs_percent ? report.efficiency_hs_percent : '')],
            p_chimney_mbar: [(report.p_chimney_mbar ? report.p_chimney_mbar : '')],
            t_unit_deg_c: [(report.t_unit_deg_c ? report.t_unit_deg_c : '')],
            p_burn_mbar: [(report.p_burn_mbar ? report.p_burn_mbar : '')],
            p_control_mbar: [(report.p_control_mbar ? report.p_control_mbar : '')],
            p_dyn_mbar: [(report.p_dyn_mbar ? report.p_dyn_mbar : '')],
            p_pump_bar: [(report.p_pump_bar ? report.p_pump_bar : '')],
            p_firebox_pa: [(report.p_firebox_pa ? report.p_firebox_pa : '')],
            smoke_index_bacharach: [(report.smoke_index_bacharach ? report.smoke_index_bacharach : '')],
            lambda: [(report.lambda ? report.lambda : '')],
            mains_voltage: [(report.mains_voltage ? report.mains_voltage : '')],
            warmwater_flow_rate: [(report.warmwater_flow_rate ? report.warmwater_flow_rate : '')],
            gas_usage_full_load: [(report.gas_usage_full_load ? report.gas_usage_full_load : '')],
            contamination: [(report.contamination ? report.contamination : '')],
            fan_voltage: [(report.fan_voltage ? report.fan_voltage : '')],
            ionization_current_ua: [(report.ionization_current_ua ? report.ionization_current_ua : '')],
          });
          break;
        case 102:
          // Druktest gasleiding (type = 102)
          // reps is the per-set rep count; lives in the FormGroup so it
          // ships through saveFormsToReports() like every other field. The
          // 9999 cap is defense-in-depth (see CLAUDE.md rep entry contract).
          form = this.formBuilder.group({
            test_type: [''],
            p_start_mbar: [''],
            p_end_mbar: [''],
            p_loss_mbar: [''],
            duration_minutes: [''],
            leak_test_sufficient: [''],
            p_stat_mbar: [''],
            p_dyn_mbar: [''],
            meter_reading: [''],
            reps: [0, [Validators.min(0), Validators.max(9999)]],
          });
          form.patchValue(report);
          // Coerce reps to a clamped integer in case the payload carried a
          // string, null, NaN or out-of-range value.
          form.get('reps').setValue(this.clampReps(report && report.reps), { emitEvent: false });
          break;
        case 103:
          // Buiten bedrijf stellen (type = 103)
          form = this.formBuilder.group({
            co_ref_ppm: [''],
            co_ppm: [''],
            co_mg_kwh: [''],
          });
          form.patchValue(report);
          break;
        case 200:
          // Ventilatie meting instellingen (type = 200)
          form = this.formBuilder.group({
            measurement_units: [(report.measurement_units ? report.measurement_units : 'ls')],
            total_capacity_measurement_in_ls: [(report.total_capacity_measurement_in_ls ? report.total_capacity_measurement_in_ls : '')],
            total_capacity_measurement_in_m3h: [(report.total_capacity_measurement_in_m3h ? report.total_capacity_measurement_in_m3h : '')],
            total_capacity_measurement_out_ls: [(report.total_capacity_measurement_out_ls ? report.total_capacity_measurement_out_ls : '')],
            total_capacity_measurement_out_m3h: [(report.total_capacity_measurement_out_m3h ? report.total_capacity_measurement_out_m3h : '')],
            notes: [(report.notes ? report.notes : '')],
          });
          break;
        case 201:
          // Volumestromen ventilatietoevoer (type = 201)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            capacity_design: [(report.capacity_design ? report.capacity_design : '')],
            capacity_measurement: [(report.capacity_measurement ? report.capacity_measurement : '')],
            capacity_design_m3h: [(report.capacity_design_m3h ? report.capacity_design_m3h : '')],
            capacity_measurement_m3h: [(report.capacity_measurement_m3h ? report.capacity_measurement_m3h : '')],
            grid_nr: [(report.grid_nr ? report.grid_nr : '')],
            setting_grid: [(report.setting_grid ? report.setting_grid : '')],
            sufficient: [(report.sufficient ? report.sufficient : '')],
            notes: [(report.notes ? report.notes : '')],
          });
          break;
        case 202:
          // Volumestromen ventilatieafvoer (type = 202)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            capacity_design: [(report.capacity_design ? report.capacity_design : '')],
            capacity_measurement: [(report.capacity_measurement ? report.capacity_measurement : '')],
            capacity_design_m3h: [(report.capacity_design_m3h ? report.capacity_design_m3h : '')],
            capacity_measurement_m3h: [(report.capacity_measurement_m3h ? report.capacity_measurement_m3h : '')],
            grid_nr: [(report.grid_nr ? report.grid_nr : '')],
            setting_grid: [(report.setting_grid ? report.setting_grid : '')],
            sufficient: [(report.sufficient ? report.sufficient : '')],
            notes: [(report.notes ? report.notes : '')],
          });
          break;
        case 203:
          // Installatiegeluid per ruimte (type = 203)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            sound_pressure_level_design: [(report.sound_pressure_level_design ? report.sound_pressure_level_design : '')],
            sound_pressure_level_measurement: [(report.sound_pressure_level_measurement ? report.sound_pressure_level_measurement : '')],
            grid_nr: [(report.grid_nr ? report.grid_nr : '')],
            setting_grid: [(report.setting_grid ? report.setting_grid : '')],
            notes: [(report.notes ? report.notes : '')],
          });
          break;
        case 204:
          // Meting luchtvolumestromen per ruimte (type = 204)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            capacity_design_setting1: [(report.capacity_design_setting1 ? report.capacity_design_setting1 : '')],
            capacity_before_setting1: [(report.capacity_before_setting1 ? report.capacity_before_setting1 : '')],
            capacity_after_setting1: [(report.capacity_after_setting1 ? report.capacity_after_setting1 : '')],
            capacity_design_setting2: [(report.capacity_design_setting2 ? report.capacity_design_setting2 : '')],
            capacity_before_setting2: [(report.capacity_before_setting2 ? report.capacity_before_setting2 : '')],
            capacity_after_setting2: [(report.capacity_after_setting2 ? report.capacity_after_setting2 : '')],
            capacity_design_setting3: [(report.capacity_design_setting3 ? report.capacity_design_setting3 : '')],
            capacity_before_setting3: [(report.capacity_before_setting3 ? report.capacity_before_setting3 : '')],
            capacity_after_setting3: [(report.capacity_after_setting3 ? report.capacity_after_setting3 : '')],
            capacity_design_setting1_m3h: [(report.capacity_design_setting1_m3h ? report.capacity_design_setting1_m3h : '')],
            capacity_before_setting1_m3h: [(report.capacity_before_setting1_m3h ? report.capacity_before_setting1_m3h : '')],
            capacity_after_setting1_m3h: [(report.capacity_after_setting1_m3h ? report.capacity_after_setting1_m3h : '')],
            capacity_design_setting2_m3h: [(report.capacity_design_setting2_m3h ? report.capacity_design_setting2_m3h : '')],
            capacity_before_setting2_m3h: [(report.capacity_before_setting2_m3h ? report.capacity_before_setting2_m3h : '')],
            capacity_after_setting2_m3h: [(report.capacity_after_setting2_m3h ? report.capacity_after_setting2_m3h : '')],
            capacity_design_setting3_m3h: [(report.capacity_design_setting3_m3h ? report.capacity_design_setting3_m3h : '')],
            capacity_before_setting3_m3h: [(report.capacity_before_setting3_m3h ? report.capacity_before_setting3_m3h : '')],
            capacity_after_setting3_m3h: [(report.capacity_after_setting3_m3h ? report.capacity_after_setting3_m3h : '')],
          });
          break;
        case 205:
          // Meting geluid per ruimte (type = 205)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            sound_pressure_level_design_setting1: [(report.sound_pressure_level_design_setting1 ? report.sound_pressure_level_design_setting1 : '')],
            sound_pressure_level_before_setting1: [(report.sound_pressure_level_before_setting1 ? report.sound_pressure_level_before_setting1 : '')],
            sound_pressure_level_after_setting1: [(report.sound_pressure_level_after_setting1 ? report.sound_pressure_level_after_setting1 : '')],
            sound_pressure_level_design_setting2: [(report.sound_pressure_level_design_setting2 ? report.sound_pressure_level_design_setting2 : '')],
            sound_pressure_level_before_setting2: [(report.sound_pressure_level_before_setting2 ? report.sound_pressure_level_before_setting2 : '')],
            sound_pressure_level_after_setting2: [(report.sound_pressure_level_after_setting2 ? report.sound_pressure_level_after_setting2 : '')],
            sound_pressure_level_design_setting3: [(report.sound_pressure_level_design_setting3 ? report.sound_pressure_level_design_setting3 : '')],
            sound_pressure_level_before_setting3: [(report.sound_pressure_level_before_setting3 ? report.sound_pressure_level_before_setting3 : '')],
            sound_pressure_level_after_setting3: [(report.sound_pressure_level_after_setting3 ? report.sound_pressure_level_after_setting3 : '')],
          });
          break;
        case 206:
          // Meting luchtdichtheid (type = 206)
          form = this.formBuilder.group({
            pressure: [(report.pressure ? report.pressure : '')],
            measured_loss: [(report.measured_loss ? report.measured_loss : '')],
            measured_loss_m3h: [(report.measured_loss_m3h ? report.measured_loss_m3h : '')],
            surface_area: [(report.surface_area ? report.surface_area : '')],
            measured_loss_surface_area: [(report.measured_loss_surface_area ? report.measured_loss_surface_area : '')],
            allowed_loss: [(report.allowed_loss ? report.allowed_loss : '')],
            measured_loss_surface_area_m3h: [(report.measured_loss_surface_area_m3h ? report.measured_loss_surface_area_m3h : '')],
            allowed_loss_m3h: [(report.allowed_loss_m3h ? report.allowed_loss_m3h : '')],
            conclusion: [(report.conclusion ? report.conclusion : '')],
            ductwork_class: [(report.ductwork_class ? report.ductwork_class : '')],
          });
          break;
        case 207:
          // ClimaLevel volumestromen toevoerrooster (type = 207)
          form = this.formBuilder.group({
            room: [(report.room ? report.room : '')],
            floor: [(report.floor ? report.floor : '')],
            floor_surface_area: [(report.floor_surface_area ? report.floor_surface_area : '')],
            capacity_design: [(report.capacity_design ? report.capacity_design : '')],
            capacity_design_m3h: [(report.capacity_design_m3h ? report.capacity_design_m3h : '')],
            number_of_grids: [(report.number_of_grids? report.number_of_grids : '')],
            grid1_length: [(report.grid1_length ? report.grid1_length : '')],
            grid1_capacity_measurement: [(report.grid1_capacity_measurement ? report.grid1_capacity_measurement : '')],
            grid1_capacity_measurement_m3h: [(report.grid1_capacity_measurement_m3h ? report.grid1_capacity_measurement_m3h : '')],
            grid2_length: [(report.grid2_length ? report.grid2_length : '')],
            grid2_capacity_measurement: [(report.grid2_capacity_measurement ? report.grid2_capacity_measurement : '')],
            grid2_capacity_measurement_m3h: [(report.grid2_capacity_measurement_m3h ? report.grid2_capacity_measurement_m3h : '')],
            grid3_length: [(report.grid3_length ? report.grid3_length : '')],
            grid3_capacity_measurement: [(report.grid3_capacity_measurement ? report.grid3_capacity_measurement : '')],
            grid3_capacity_measurement_m3h: [(report.grid3_capacity_measurement_m3h ? report.grid3_capacity_measurement_m3h : '')],
            grid4_length: [(report.grid4_length ? report.grid4_length : '')],
            grid4_capacity_measurement: [(report.grid4_capacity_measurement ? report.grid4_capacity_measurement : '')],
            grid4_capacity_measurement_m3h: [(report.grid4_capacity_measurement_m3h ? report.grid4_capacity_measurement_m3h : '')],
            grid5_length: [(report.grid5_length ? report.grid5_length : '')],
            grid5_capacity_measurement: [(report.grid5_capacity_measurement ? report.grid5_capacity_measurement : '')],
            grid5_capacity_measurement_m3h: [(report.grid5_capacity_measurement_m3h ? report.grid5_capacity_measurement_m3h : '')],
            sufficient: [(report.sufficient ? report.sufficient : '')],
          });
          break;
        case 301:
          // Meting luchtdichtheid (type = 301)
          form = this.formBuilder.group({
            watermeter: [(report.watermeter ? report.watermeter : '')],
            input_hardness: [(report.input_hardness ? report.input_hardness : '')],
            input_temperature: [(report.input_temperature ? report.input_temperature : '')],
            input_water_pressure: [(report.input_water_pressure ? report.input_water_pressure : '')],
            output_hardness: [(report.output_hardness ? report.output_hardness : '')],
            output_temperature: [(report.output_temperature ? report.output_temperature : '')],
            output_water_pressure: [(report.output_water_pressure ? report.output_water_pressure : '')],
            output_measurement_location: [(report.output_measurement_location ? report.output_measurement_location : '')],
          });
          break;
        case 401:
          // Meting hijstoestel (type = 401)
          form = this.formBuilder.group({
            output_temperature: [(report.output_temperature ? report.output_temperature : '')],
          });
          break;
        case 501:
          // Airco (type = 501)
          form = this.formBuilder.group({
            airco_setting: [(report.airco_setting ? report.airco_setting : '')],
            liquid_temperature: [(report.liquid_temperature ? report.liquid_temperature : '')],
            temperature_high: [(report.temperature_high ? report.temperature_high : '')],
            temperature_low: [(report.temperature_low ? report.temperature_low : '')],
            pressure_high: [(report.pressure_high ? report.pressure_high : '')],
            pressure_low: [(report.pressure_low ? report.pressure_low : '')],
            amperes: [(report.amperes ? report.amperes : '')],
            voltage: [(report.voltage ? report.voltage : '')],
            frequency: [(report.frequency ? report.frequency : '')],
            pressure_part_high: [(report.pressure_part_high ? report.pressure_part_high : '')],
            pressure_part_low: [(report.pressure_part_low ? report.pressure_part_low : '')],
            pressure_testing_temperature_input: [(report.pressure_testing_temperature_input ? report.pressure_testing_temperature_input : '')],
            pressure_testing_temperature_output: [(report.pressure_testing_temperature_output ? report.pressure_testing_temperature_output : '')],
            overheating: [(report.overheating ? report.overheating : '')],
            vacuum_pressure: [(report.vacuum_pressure ? report.vacuum_pressure : '')],
            times_broken_n2_time: [(report.times_broken_n2_time ? report.times_broken_n2_time : '')],
            add_coolant: [(report.add_coolant ? report.add_coolant : '')],
            return_coolant: [(report.return_coolant ? report.return_coolant : '')],
            passport_nr_bottle: [(report.passport_nr_bottle ? report.passport_nr_bottle : '')],
            type_of_gas: [(report.type_of_gas ? report.type_of_gas : '')],
            amount_in_bottle_before: [(report.amount_in_bottle_before ? report.amount_in_bottle_before : '')],
            amount_in_bottle_after: [(report.amount_in_bottle_after ? report.amount_in_bottle_after : '')],
            performed_activities: [(report.performed_activities ? report.performed_activities : '')],
          });
          break;
        case 701:
          // Gasdrukmeting (type = 701)
          form = this.formBuilder.group({
            measurement_point_available: [''],
            device_id: [''],
            p_stat_mbar: [''],
            p_dyn_mbar: [''],
            p_plumbing_start_mbar: [''],
            p_plumbing_end_mbar: [''],
            p_lost_3min_mbar: [''],
            device_type: [''],
            device_sn: [''],
            device_last_service_date: [''],
          });
          form.patchValue(report);
          break;
        case 901:
          // Rookgasmeting gas- of sfeerhaard (type = 901)
          form = this.formBuilder.group({
            _expanded: [(report._expanded ? report._expanded : false)],
            moment_of_measurement: [(report.moment_of_measurement ? report.moment_of_measurement : '')],
            co_ppm: [(report.co_ppm ? report.co_ppm : ''), Validators.required],
            co_mg_kwh: [(report.co_mg_kwh ? report.co_mg_kwh : '')],
            co_ref_ppm: [(report.co_ref_ppm ? report.co_ref_ppm : ''), (this.country != 'BE' ? Validators.required : null)],
            co_ref_test_ppm: [(report.co_ref_test_ppm ? report.co_ref_test_ppm : ''), (this.country != 'BE' ? Validators.required : null)],
            co2_percent: [(report.co2_percent ? report.co2_percent : ''), Validators.required],
            o2_percent: [(report.o2_percent ? report.o2_percent : ''), Validators.required],
            t_air_deg_c: [(report.t_air_deg_c ? report.t_air_deg_c : ''), Validators.required],
            device_id: [(report.device_id ? report.device_id : '')],
            device_sn: [(report.device_sn ? report.device_sn : '')],
            device_type: [(report.device_type ? report.device_type : '')],
            device_last_service_date: [(report.device_last_service_date ? report.device_last_service_date : '')],
          });
          if(this.data.workorder_type == '3' || this.data.workorder_type == '4' || this.data.workorder_type == '5' || this.data.workorder_type == '6') {
            /* Rookgasmeting niet verplicht bij storing, recyclage, aanmelden unit of garantiekaart, wel bij ander workorder_type */
            this.required = false;
          } else if(this.data._selected_unit && this.data._selected_unit.openings == 'Nee'){
            /* Rookgasmeting niet verplicht als de geselecteerde unit geen openingen heeft */
            this.required = false;
          } else {
            this.required = true;
          }
          break;
        case 1001:
          // Grasmaaier meting (type = 1001)
          form = this.formBuilder.group({
            battery_voltage: [''],
            battery_capacity: [''],
            blade_thickness: ['', Validators.required],
          });
          form.patchValue(report);
          break;
        default:
          // Rookgasmeting (type = 100)
          form = this.formBuilder.group({
            _expanded: [(report._expanded ? report._expanded : false)],
            moment_of_measurement: [(report.moment_of_measurement ? report.moment_of_measurement : '')],
            co_ppm: [(report.co_ppm ? report.co_ppm : ''), Validators.required],
            co_mg_kwh: [(report.co_mg_kwh ? report.co_mg_kwh : '')],
            co_ref_ppm: [(report.co_ref_ppm ? report.co_ref_ppm : ''), (this.country != 'BE' ? Validators.required : null)],
            co_ref_end_ppm: [(report.co_ref_end_ppm ? report.co_ref_end_ppm : ''), (this.country != 'BE' ? Validators.required : null)],
            co2_percent: [(report.co2_percent ? report.co2_percent : ''), Validators.required],
            o2_percent: [(report.o2_percent ? report.o2_percent : ''), Validators.required],
            o2_intake_percent: [(report.o2_intake_percent ? report.o2_intake_percent : '')],
            co_intake_percent: [(report.co_intake_percent ? report.co_intake_percent : '')],
            co2_intake_percent: [(report.co2_intake_percent ? report.co2_intake_percent : '')],
            t_flue_deg_c: [(report.t_flue_deg_c ? report.t_flue_deg_c : ''), Validators.required],
            t_air_deg_c: [(report.t_air_deg_c ? report.t_air_deg_c : ''), Validators.required],
            t_delta_deg_c: [(report.t_delta_deg_c ? report.t_delta_deg_c : '')],
            efficiency_hi_percent: [(report.efficiency_hi_percent ? report.efficiency_hi_percent : '')],
            efficiency_hs_percent: [(report.efficiency_hs_percent ? report.efficiency_hs_percent : '')],
            p_chimney_mbar: [(report.p_chimney_mbar ? report.p_chimney_mbar : '')],
            p_stat_mbar: [(report.p_stat_mbar ? report.p_stat_mbar : '')],
            p_pump_bar: [(report.p_pump_bar ? report.p_pump_bar : '')],
            p_firebox_pa: [(report.p_firebox_pa ? report.p_firebox_pa : '')],
            p_dyn_mbar: [(report.p_dyn_mbar ? report.p_dyn_mbar : ''), (this.unitFuelType != 'Stookolie / Mazout' ? Validators.required : null)],
            p_burn_mbar: [(report.p_burn_mbar ? report.p_burn_mbar : '')],
            p_control_mbar: [(report.p_control_mbar ? report.p_control_mbar : '')],
            smoke_index_bacharach: [(report.smoke_index_bacharach ? report.smoke_index_bacharach : '')],
            lambda: [(report.lambda ? report.lambda : '')],
            t_unit_deg_c: [(report.t_unit_deg_c ? report.t_unit_deg_c : '')],
            mains_voltage: [(report.mains_voltage ? report.mains_voltage : '')],
            warmwater_flow_rate: [(report.warmwater_flow_rate ? report.warmwater_flow_rate : '')],
            gas_usage_full_load: [(report.gas_usage_full_load ? report.gas_usage_full_load : '')],
            contamination: [(report.contamination ? report.contamination : '')],
            fan_voltage: [(report.fan_voltage ? report.fan_voltage : '')],
            ionization_current_ua: [(report.ionization_current_ua ? report.ionization_current_ua : '')],
            device_id: [(report.device_id ? report.device_id : '')],
            device_sn: [(report.device_sn ? report.device_sn : '')],
            device_type: [(report.device_type ? report.device_type : '')],
            device_last_service_date: [(report.device_last_service_date ? report.device_last_service_date : '')],
            reason_first_report_not_possible: [(report.reason_first_report_not_possible ? report.reason_first_report_not_possible : '')],
            under_pressure_checked: [(report.under_pressure_checked ? report.under_pressure_checked : '')],
          });
          if(this.data.workorder_type == '3' || this.data.workorder_type == '4' || this.data.workorder_type == '5' || this.data.workorder_type == '6') {
            /* Rookgasmeting niet verplicht bij storing, recyclage, aanmelden unit of garantiekaart, wel bij ander workorder_type */
            this.required = false;
          } else if(this.data._selected_unit && this.data._selected_unit.openings == 'Nee'){
            /* Rookgasmeting niet verplicht als de geselecteerde unit geen openingen heeft */
            this.required = false;
          } else {
            this.required = true;
          }
          break;
      }
      if(form) {
        this.forms.push(form);
      }
    }
    // Get devices
    this.devices = [];
  }

  setSelectedDevice(device){
    this.selectedDevice = device;
    let i = 0;
    for(let report of this.reports){
      let form = this.forms[i];
      if(report.type == 100 || report.type == 701 || report.type == 901){
        form.patchValue({
          device_id: this.selectedDevice.device_id,
          device_sn: this.selectedDevice.sn,
          device_type: (this.selectedDevice.device_brand + ' ' + this.selectedDevice.device_model),
          device_last_service_date: this.selectedDevice.last_service_date
        });
      }
    }
  }

  onSelectedDeviceChange(form: FormGroup){
    console.log('onSelectedDeviceChange');
    let values = form.value;
    for(let d of this.devices){
      if(d.device_id == values.device_id){
        this.setSelectedDevice(d);
      }
    }
  }

  calculateDeltaT(form: FormGroup){
    console.log('calculateDeltaT');
    console.log(form.value);
    if(form.value && form.value.t_air_deg_c && form.value.t_flue_deg_c){
      console.log('found');
      let delta_t = Math.round(Math.abs(parseFloat(form.value.t_air_deg_c) - parseFloat(form.value.t_flue_deg_c)) * 10) / 10;
      form.patchValue({ 't_delta_deg_c': delta_t });
    }
  }

  public convertPpmToMgKwh(form: FormGroup){
    let ppm_value = parseFloat(form.get('co_ppm').value);
    if(ppm_value > 0){
      let mg_kwh_value = Math.round(ppm_value * 0.0409 * 16.04 * 100) / 100;
      form.get('co_mg_kwh').setValue(mg_kwh_value);
    }
  }

  public convertMgKwhToPpm(form: FormGroup){
    let mg_kwh_value = parseFloat(form.get('co_mg_kwh').value);
    if(mg_kwh_value > 0){
      let ppm_value = Math.round(mg_kwh_value / 0.0409 / 16.04 * 100) / 100;
      form.get('co_ppm').setValue(ppm_value);
    }
  }

  public convertEfficiencyHsToHi(form){
    if(form.value.efficiency_hs_percent && parseFloat(form.value.efficiency_hs_percent) > 0){
      let value= Math.round(parseFloat(form.value.efficiency_hs_percent) * 1.1 * 10) / 10;
      form.get('efficiency_hi_percent').setValue(value);
    }
  }

  public convertEfficiencyHiToHs(form){
    if(form.value.efficiency_hi_percent && parseFloat(form.value.efficiency_hi_percent) > 0){
      let value= Math.round(parseFloat(form.value.efficiency_hi_percent) / 1.1 * 10) / 10;
      form.get('efficiency_hs_percent').setValue(value);
    }
  }

  setLinkedField(source_value: string, form: FormGroup, target_type: string, target_field: string){
    if(!source_value){
      form.get(target_field).setValue('');
    }
    let target_value = null;
    if(target_type == 'ls' && source_value){
      target_value = Math.round(parseFloat(source_value) / 3.6 * 100) / 100;
      form.get(target_field).setValue(target_value);
    }
    if(target_type == 'm3h' && source_value){
      target_value = Math.round(parseFloat(source_value) * 3.6 * 100) / 100;
      form.get(target_field).setValue(target_value);
    }
    // Calculate totals
    if(target_field == 'capacity_measurement' || target_field == 'capacity_measurement_m3h'){
      setTimeout(() => {
        this.calculateReportType200();
      }, 200);
    }
  }

  calculateReportType200(){
    if(this.reports.length === 0){
      return;
    }
    // Create record
    let record = {
      total_capacity_measurement_in_ls: 0,
      total_capacity_measurement_in_m3h: 0,
      total_capacity_measurement_out_ls: 0,
      total_capacity_measurement_out_m3h: 0
    };
    // Calculate totals from report type 201, 202
    let i = 0;
    for(let report of this.reports){
      let values = this.forms[i].value;
      if(report.type == 201){
        record.total_capacity_measurement_in_ls += Math.round(parseFloat(values.capacity_measurement) * 10) / 10;
        record.total_capacity_measurement_in_m3h += Math.round(parseFloat(values.capacity_measurement_m3h) * 10) / 10;
      }
      if(report.type == 202){
        record.total_capacity_measurement_out_ls += Math.round(parseFloat(values.capacity_measurement) * 10) / 10;
        record.total_capacity_measurement_out_m3h += Math.round(parseFloat(values.capacity_measurement_m3h) * 10) / 10;
      }
      i++;
    }
    // Set totals in report type 290
    i = 0;
    for(let report of this.reports){
      if(report.type == 200) {
        this.forms[i].patchValue(record);
        Object.assign(report, record);
      }
      i++;
    }
  }

  addPhoto(report_index){
    this.alertCtrl.create({
      title: this.translate.instant('Foto toevoegen'),
      cssClass: 'alert-not-bold',
      buttons: [
        {
          text: this.translate.instant('Nieuwe foto maken'),
          handler: () => {
            this.getPicture(report_index, this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: this.translate.instant('Kies foto uit fotoalbum'),
          handler: () => {
            this.getPicture(report_index, this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        }
      ]
    }).present();
  }

  getPicture(report_index, sourceType){
    this.camera.getPicture({
      quality: 60,
      targetWidth: 1200,
      targetHeight: 1200,
      correctOrientation: true,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }).then((imageData) => {
      let src = 'data:image/jpeg;base64,' + imageData;
      if(!this.reports[report_index].photos){
        this.reports[report_index].photos = [];
      }
      this.reports[report_index].photos.push({
        title: '',
        src: src
      });
    }, (err) => {
      this.changeDetector.detectChanges();
    });
  }

  removePhoto(report_index, index){
    this.alertCtrl.create({
      title: this.translate.instant('Foto verwijderen'),
      message: this.translate.instant('Wilt u deze foto verwijderen?'),
      buttons: [
        {
          text: this.translate.instant('Nee'),
          role: 'cancel'
        },{
          text: this.translate.instant('Ja'),
          handler: () => {
            this.reports[report_index].photos.splice(index, 1);
          }
        }
      ]
    }).present();
  }

  viewPhoto(photo, report_index, index){
    this.modalCtrl.create(ViewPhotoPage, {
      photo: photo,
      photos: this.reports[report_index].photos,
      index: index
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  ionViewDidEnter() {
    console.log('ReportMeasurementPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportMeasurementPage: ionViewDidLeave');
    this.save();
  }

  isValid(){
    let index = 0;
    if(!this.hasProSubscription){
      return true;
    }
    if(!this.enabled){
      return false;
    }
    let rookgasmetingen = 0;
    let first_report_not_possible = false;
    for(let report of this.reports){
      let form: FormGroup = this.forms[index];
      if(report.type == 100 && (!form.valid && this.required)){
        return false;
      }
      if(report.type == 100 || report.type == 101) {
        rookgasmetingen++;
      }
      if(form.get('reason_first_report_not_possible') && form.get('reason_first_report_not_possible').value){
        first_report_not_possible = true;
      }
      index++;
    }
    // In Belgie zijn 2 rookgasmetingen verplicht, tenzij de eerste meting niet mogelijk is.
    if (this.country == 'BE' && rookgasmetingen == 1 && !first_report_not_possible){
      return false;
    }
    // Return valid
    return true;
  }

  saveFormsToReports(){
    if(this.reports.length === 0){
      return;
    }
    let i = 0;
    for(let report of this.reports){
      report._unit_id = ((this.data._selected_units && this.data._selected_units[0] && this.data._selected_units[0]._unit_id != null) ? this.data._selected_units[0]._unit_id : '');
      Object.assign(report, this.forms[i].value);
      console.log(this.forms[i].value);
      i++;
    }
    console.log(this.reports);
    this.data.reports = this.reports;
  }

  save(){
    for(let form of this.forms){
      form.markAsTouched();
    }
    this.saveFormsToReports();
    if(this.isValid()){
      this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportMeasurementPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_error', 'mainTabs');
      this.data._valid.reportMeasurementPage = -1;
    }
    if(!this.data._current_report) this.data._current_report = {};
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportChecklistPage', 'mainTabs');
    });
  }

  public openInfo(title, text){
    console.log('openInfo');
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

  public getMeasurement(form: FormGroup){
    this.showNotAvailableAlert(form);
  }

  public getMeasurementTestoBle(form: FormGroup){
    this.showNotAvailableAlert(form);
  }

  public getMRUMeasurement(form: FormGroup, fuel){
    this.showNotAvailableAlert(form);
  }

  public showNotAvailableAlert(form: FormGroup){
    this.alertCtrl.create({
      message: this.translate.instant("Voor deze XPRNZ dient u 'Via QR code' te selecteren."),
      buttons: [
        {
          text: this.translate.instant('OK'),
          handler: () => {
            this.chooseType(form)
          }
        }
      ]
    }).present();
  }

  public showInvalidQrCodeAlert(){
    this.alertCtrl.create({
      message: this.translate.instant('Deze QR code hoort niet bij een rookgasmeting.'),
      buttons: ['OK']
    }).present();
  }

  public chooseType(form: FormGroup){
    // Show selector
    let buttons = [];
    buttons.push({
      text: this.translate.instant('Via QR code'),
      handler: () => {
        this.scanDummy(form);
      }
    });
    buttons.push({
      text: this.translate.instant('Via Bluetooth'),
      handler: () => {
        this.showNotAvailableAlert(form);
      }
    });
    buttons.push({
      text: this.translate.instant('Via Wifi'),
      handler: () => {
        this.showNotAvailableAlert(form);
      }
    });
    this.alertCtrl.create({
      title: this.translate.instant('Wijze van overdracht meetgegevens'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public chooseMRUFuel(form: FormGroup) {
    this.alertCtrl.create({
      title: this.translate.instant('Kies brandstof'),
      cssClass: 'alert-not-bold',
      buttons: [
        { text: this.translate.instant('Aardgas'), handler: () => { this.getMRUMeasurement(form, 'FUEL_NAT_GAS'); }},
        { text: this.translate.instant('Butaan'), handler: () => { this.getMRUMeasurement(form, 'FUEL_BUTANE'); }},
        { text: this.translate.instant('Pellets'), handler: () => { this.getMRUMeasurement(form, 'FUEL_PELLETS'); }},
        { text: this.translate.instant('Propaan'), handler: () => { this.getMRUMeasurement(form, 'FUEL_PROPANE'); }},
        { text: this.translate.instant('Overig'), handler: () => { this.getMRUMeasurement(form, 'FUEL_OTHER'); }}
      ]
    }).present();
  }

  scanDummy(form: FormGroup){
    let dummyData = Object.assign({}, this.dummyData);
    if(this.forms.length == 1){
      dummyData.moment_of_measurement = this.translate.instant('Voor het onderhoud');
      dummyData._expanded = true;
    } else {
      dummyData.moment_of_measurement = this.translate.instant('Na het onderhoud');
      dummyData._expanded = false;
    }
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      if(data.text){
        let qr_data = data.text;
        let rows_euroindex = qr_data.split('\n');
        let rows_drager = qr_data.split(';');
        if(rows_euroindex.length > 3){
          dummyData.device_type = 'EURO-INDEX rookgasmeter';
        } else if(rows_drager.length > 3){
          dummyData.device_type = 'Dräger rookgasmeter';
        } else {
          // Invalid QR code
          this.showInvalidQrCodeAlert();
          return;
        }
        form.patchValue(dummyData);
        // Set t_delta_deg_c
        this.calculateDeltaT(form);
        // Convert Efficiency Hi to Hs
        if(form.value.efficiency_hi_percent && !form.value.efficiency_hs_percent){
          this.convertEfficiencyHiToHs(form);
        } else if (form.value.efficiency_hs_percent && !form.value.efficiency_hi_percent) {
          this.convertEfficiencyHsToHi(form);
        }
        if(form.value.co_mg_kwh && !form.value.co_ppm){
          this.convertMgKwhToPpm(form);
        } else if (form.value.co_ppm && !form.value.co_mg_kwh) {
          this.convertPpmToMgKwh(form);
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  scanBarcode(form: FormGroup, field){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if((field == 'passport_nr' || field == 'passport_nr_bottle') && barcode.lastIndexOf('/') > 0){
        barcode = barcode.substring(barcode.lastIndexOf('/')+1);
      }
      if(barcode){
        form.get(field).setValue(barcode);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  public scanEuroindexQR(form: FormGroup){
    let mapping = [
      ['27', 'co_ppm'],
      ['29', 'co_mg_kwh'],
      ['36', 'co2_percent'],
      ['26', 'o2_percent'],
      ['5', 't_flue_deg_c'],
      ['7', 't_air_deg_c'],
      ['12', 'p_chimney_mbar'],
      ['63', 'efficiency_hi_percent'],
      ['62', 'efficiency_hs_percent'],
      ['65', 'lambda'],
      ['248', 'device_sn']
    ];
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Euroindex data', data);
      if(data.text){
        let qr_data = data.text;
        let rows = qr_data.split('\n');
        let valid = false;
        if(rows.length){
          for(let j = 0; j < rows.length; j++){
            let row = rows[j];
            let cols = row.split(';');
            if(cols.length == 2){
              let id = cols[0].trim();
              let value = cols[1].trim();
              if(value == '----' || value == '---'){
                continue;
              }
              for(let q = 0; q < mapping.length; q++){
                if(mapping[q][0] == id){
                  valid = true;
                  if(form.get(mapping[q][1])){
                    form.get(mapping[q][1]).setValue(value);
                  }
                }
              }
            }
          }
        }
        // Set t_delta_deg_c
        if(valid){
          this.calculateDeltaT(form);
        }
        // Convert Efficiency Hi to Hs
        if(form.value.efficiency_hi_percent && !form.value.efficiency_hs_percent){
          this.convertEfficiencyHiToHs(form);
        } else if (form.value.efficiency_hs_percent && !form.value.efficiency_hi_percent) {
          this.convertEfficiencyHsToHi(form);
        }
        if(form.value.co_mg_kwh && !form.value.co_ppm){
          this.convertMgKwhToPpm(form);
        } else if (form.value.co_ppm && !form.value.co_mg_kwh) {
          this.convertPpmToMgKwh(form);
        }
        // If QR data is invalid, display message
        if(!valid){
          this.alertCtrl.create({
            title: this.translate.instant('Fout'),
            message: 'De gescande code bevat geen meetgegevens.',
            cssClass: 'alert-error',
            buttons: ['OK']
          }).present();
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  public scanMRUQR(form: FormGroup){
    let mapping = [
      ['2_4', 'co_ppm'], // CO_Dil_Exh UNIT_PPM
      ['0_2', 'co2_percent'], // CO2 UNIT_VOL_PERCENT
      ['17_2', 'o2_percent'], // O2 UNIT_VOL_PERCENT
      ['36_3', 't_flue_deg_c'], // T_Flue UNIT_DEG_C
      ['33_3', 't_air_deg_c'], // T_Air UNIT_DEG_C
      ['23_12', 'p_chimney_mbar'], // P_Draft UNIT_MBAR
      ['8_1', 'efficiency_hi_percent'], // Efficiency UNIT_PERCENT
      ['10_0', 'lambda'], // Lambda UNIT_NONE
      ['9', 'device_sn'] // InstrumentId
    ];
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('MRU data', data);
      if(data.text){
        let qr_data = data.text;
        let rows = qr_data.split('\n');
        let valid = false;
        let section = '';
        let device_sn = '';
        if(rows.length){
          for(let j = 0; j < rows.length; j++){
            let row = rows[j];
            row = row.trim();
            if(row.substr(0,2) == '</'){
              section = '';
              continue;
            }
            if(row.substr(0,1) == '<'){
              section = row;
              continue;
            }
            if(section == '<Instrument>'){
              device_sn = row;
            }
            if(section == '<OilGasMeas>'){
              let cols = row.split(';');
              if(cols.length == 2 || cols.length == 3){
                let id = cols[0].trim();
                let value = cols[1].trim();
                if(cols.length == 3){
                  id += '_' + cols[2];
                }
                if(value == '----' || value == '---' || value == '-1'){
                  continue;
                }
                for(let q = 0; q < mapping.length; q++){
                  if(mapping[q][0] == id){
                    valid = true;
                    if(form.get(mapping[q][1])) {
                      form.get(mapping[q][1]).setValue(value);
                    }
                  }
                }
              }
            }

          }
        }
        // Set device_sn
        if(device_sn && form.get('device_sn')){
          form.get('device_sn').setValue(device_sn);
        }
        // Set t_delta_deg_c
        if(valid){
          this.calculateDeltaT(form);
        }
        // Convert Efficiency Hi to Hs
        this.convertEfficiencyHiToHs(form);
        this.convertPpmToMgKwh(form);
        // If QR data is invalid, display message
        if(!valid){
          this.alertCtrl.create({
            title: this.translate.instant('Fout'),
            message: 'De gescande code bevat geen meetgegevens.',
            cssClass: 'alert-error',
            buttons: ['OK']
          }).present();
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  public scanDraegerQR(form: FormGroup){
    let mapping = [
      ['53', 'co_ppm'],
      ['52', 'co2_percent'],
      ['51', 'o2_percent'],
      ['40', 't_air_deg_c'],
      ['41', 't_flue_deg_c'],
      ['80', 'p_chimney_mbar'],
      ['514', 'efficiency_hs_percent'],
      ['92', 'lambda'],
      ['12', 'device_sn'],
      ['11', 'device_type'],
    ];
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      // let data = { text: '11GFG4200;12GKRFN-3127;22G13:22;23G20200910;24GBrabantWonen Centraal;25G0012204;26G01;31GAardgas L;51G4.5;53G22;41G57.0;40G20.0;52G9.2;54G28;515G53;90G1.8;514G98.2;92G1.27;522G0.024;42G 60;' };
      console.log('Draeger data', data);
      if(data.text){
        let qr_data = data.text;
        let rows = qr_data.split(';');
        let valid = false;
        if(rows.length){
          for(let j = 0; j < rows.length; j++){
            let row = rows[j];
            row = row.trim();
            if(row.indexOf('G') > 0){
              let id = row.substr(0, row.indexOf('G'));
              let value = row.substr(row.indexOf('G') + 1);
              if(value == '----' || value == '---' || value == '-1'){
                continue;
              }
              for(let q = 0; q < mapping.length; q++){
                if(mapping[q][0] == id){
                  valid = true;
                  if(form.get(mapping[q][1])) {
                    form.get(mapping[q][1]).setValue(value);
                  }
                }
              }
            }
          }
        }
        // Set t_delta_deg_c
        if(valid){
          this.calculateDeltaT(form);
        }
        this.convertPpmToMgKwh(form);
        this.convertEfficiencyHsToHi(form);
        // If QR data is invalid, display message
        if(!valid){
          this.alertCtrl.create({
            title: this.translate.instant('Fout'),
            message: 'De gescande code bevat geen meetgegevens.',
            cssClass: 'alert-error',
            buttons: ['OK']
          }).present();
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  public scanTestoZivQR(form: FormGroup){
    let mapping = [
      ['50', 'o2_percent'],
      ['52', 'co2_percent'],
      ['79', 'co_ppm'],
      ['73', 'co_mg_kwh'],
      ['70', 'co_ref_ppm'],
      ['720', 'p_stat_mbar'],
      ['730', 'p_dyn_mbar'],
      ['92', 'lambda'],
      ['91', 'efficiency_hi_percent'],
      ['40', 't_air_deg_c'],
      ['41', 't_flue_deg_c'],
      ['102', 'device_sn'],
      ['105', 'device_last_service_date'],
      ['101', 'device_type'],
    ];
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      /*
      let data = { text: '1G1\n' +
          '3G1\n' +
          '4G1\n' +
          '5G1\n' +
          '100GTesto SE & Co. KGaA\n' +
          '101Gtesto 300\n' +
          '102G61349163\n' +
          '103GVDI 4206, DIN EN 50379-1\n' +
          '104GPROP_SINGLE PROP_INSTRUMENT_ID\n' +
          '105G2018-01-01\n' +
          '107GTT3661349163Xyz0219\n' +
          '5G2\n' +
          '121GTest\n' +
          '25GTest\n' +
          '5G3\n' +
          '27G1\n' +
          '121GTest\n' +
          '125GCOUNTRY_AUSTRIA\n' +
          '26GTestsite\n' +
          '5G4\n' +
          '5G5\n' +
          '31GHeizöl HEL\n' +
          '32G0\n' +
          '33G15.4\n' +
          '36G3.0\n' +
          '5G7\n' +
          '23G12/02/2010\n' +
          '22G03:24\n' +
          '107GTT3661349163Xyz0219\n' +
          '41N----\n' +
          '50G21.0\n' +
          '71N----\n' +
          '92N----\n' +
          '79G0\n' +
          '70N----\n' +
          '90N----\n' +
          '91N----\n' +
          '40G25.7\n' +
          '52N----\n' +
          '93N----\n' +
          '80G0.0\n' +
          '20G\n' };
       */
      console.log('Testo ZIV data', data);
      if(data.text){
        let qr_data = data.text;
        let rows = qr_data.split('\n');
        let valid = false;
        if(rows.length){
          for(let j = 0; j < rows.length; j++){
            let row = rows[j];
            row = row.trim();
            if(row.indexOf('G') > 0){
              let id = row.substr(0, row.indexOf('G'));
              let value = row.substr(row.indexOf('G') + 1);
              if(value == '----' || value == '---' || value == '-1'){
                continue;
              }
              for(let q = 0; q < mapping.length; q++){
                if(mapping[q][0] == id){
                  valid = true;
                  if(form.get(mapping[q][1])) {
                    form.get(mapping[q][1]).setValue(value);
                  }
                }
              }
            }
          }
        }
        // Set t_delta_deg_c
        if(valid){
          this.calculateDeltaT(form);
        }
        // Convert Efficiency Hi to Hs
        this.convertEfficiencyHiToHs(form);
        if(form.value.co_mg_kwh && !form.value.co_ppm){
          this.convertMgKwhToPpm(form);
        } else if (form.value.co_ppm && !form.value.co_mg_kwh) {
          this.convertPpmToMgKwh(form);
        }
        // If QR data is invalid, display message
        if(!valid){
          this.alertCtrl.create({
            title: this.translate.instant('Fout'),
            message: 'De gescande code bevat geen meetgegevens.',
            cssClass: 'alert-error',
            buttons: ['OK']
          }).present();
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  addReport(type){
    this.saveFormsToReports();
    this.reports.push({
      type: type
    });
    this.initForm();
  }

  deleteReport(index){
    this.saveFormsToReports();
    if (index > -1) {
      this.reports.splice(index, 1);
    }
    this.initForm();
  }

  getReportTypeCount(type){
    let count = 0;
    for(let report of this.reports){
      if(report.type == type){
        count++;
      }
    }
    return count;
  }

  isFirstOfType(type, index) {
    for(let i = 0; i < index; i++){
      if(this.reports[i].type == type){
        return false;
      }
    }
    return true;
  }

  sortReports(){
    if(this.reports.length === 0){
      return;
    }
    this.reports.sort((a, b) => {
      let type_a = a.type;
      let type_b = b.type;
      // 102 altijd onderaan sorteren
      if(type_a === 102){
        type_a = 1000102;
      }
      if(type_b === 102){
        type_b = 1000102;
      }
      if (type_a > type_b) return 1;
      if (type_b > type_a) return -1;
      return 0;
    });
  }

  addVentilatieReport(){
    let buttons = [
      {
        text: 'Volumestromen ventilatietoevoer',
        handler: () => {
          this.addReport(201);
        }
      },
      {
        text: 'Volumestromen ventilatieafvoer',
        handler: () => {
          this.addReport(202);
        }
      },
      {
        text: 'Installatiegeluid (per ruimte)',
        handler: () => {
          this.addReport(203);
        }
      },
      {
        text: 'Luchtvolumestromen (per ruimte)',
        handler: () => {
          this.addReport(204);
        }
      },
      {
        text: 'Meting geluid (per ruimte)',
        handler: () => {
          this.addReport(205);
        }
      },
      {
        text: 'Meting luchtdichtheid',
        handler: () => {
          this.addReport(206);
        }
      },
      {
        text: 'ClimaLevel volumestromen toevoerrooster',
        handler: () => {
          this.addReport(207);
        }
      },
    ];
    this.alertCtrl.create({
      title: 'Meting toevoegen',
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  /* ---- Rep counter (type-102) ----------------------------------------------
     Per-set handlers; reps live in forms[i].get('reps'). Tap, undo, +10, -10
     and typed entry all funnel through setReps(i, n) so the FormControl is
     the single source of truth. Clamped to 0..9999 (defense-in-depth; spec
     allows arbitrarily high counts in principle but a 4-digit ceiling keeps
     layout/aria-live/persistence sane against paste-bombs).
     Draft persistence is intentionally NOT handled here: saveFormsToReports()
     copies forms[i].value into report on view leave, and the existing report
     service is the durable store for the in-progress workout.
     -------------------------------------------------------------------------- */
  public clampReps(n: any): number {
    let v = parseInt(n, 10);
    if (isNaN(v) || !isFinite(v)) { v = 0; }
    if (v < 0) { v = 0; }
    if (v > 9999) { v = 9999; }
    return v;
  }

  public getReps(i: number): number {
    let ctrl = this.forms && this.forms[i] ? this.forms[i].get('reps') : null;
    return ctrl ? this.clampReps(ctrl.value) : 0;
  }

  public setReps(i: number, n: any): void {
    let ctrl = this.forms && this.forms[i] ? this.forms[i].get('reps') : null;
    if (!ctrl) { return; }
    let v = this.clampReps(n);
    let prev = this.clampReps(ctrl.value);
    if (ctrl.value !== v) {
      ctrl.setValue(v, { emitEvent: false });
    }
    // Pulse-flash on the big counter when the delta is >= 5 (mirrors web/).
    if (Math.abs(v - prev) >= 5) {
      this.bumpReps[i] = true;
      setTimeout(() => { this.bumpReps[i] = false; }, 280);
    }
    // Web-parity persistence: every tap / +10 / -10 / undo / typed-blur path
    // funnels through setReps, so saving here covers every non-keystroke
    // mutation. onRepInput intentionally does NOT call setReps (it writes
    // the FormControl directly), so per-keystroke does not pay this cost.
    this.saveFormsToReports();
  }

  public onRepTap(i: number): void {
    this.setReps(i, this.getReps(i) + 1);
    // Keep the <input> in sync. [attr.value] only paints once after the user
    // first interacts with the field, so without this the typed-into input
    // shows a stale value after tap-zone presses. Mirrors +10/-10 path.
    this.syncRepInputValue(i);
  }

  public onRepUndo(i: number): void {
    let v = this.getReps(i);
    if (v <= 0) { return; }
    this.setReps(i, v - 1);
    this.syncRepInputValue(i);
  }

  public onRepPlus10(i: number): void {
    let v = this.getReps(i);
    this.setReps(i, v + 10);
    // The input may be in the DOM and not yet showing the new value because
    // we use [attr.value] (initial-only render). Sync it imperatively when
    // it is NOT focused; if it IS focused the typing handler owns the field.
    this.syncRepInputValue(i);
  }

  public onRepMinus10(i: number): void {
    let v = this.getReps(i);
    if (v <= 0) { return; }
    this.setReps(i, v - 10);  // clampReps floors at 0
    this.syncRepInputValue(i);
  }

  public onRepInput(i: number, ev: any): void {
    // Strip non-digits while preserving caret position. Mirrors web/ P0-W1:
    // capture caret BEFORE the strip and place it at
    //   min(pos - (raw.length - cleaned.length), cleaned.length)
    // so mid-string edits don't fling the caret to the end.
    if (!ev || !ev.target) { return; }
    let inputEl: HTMLInputElement = ev.target;
    let raw = String(inputEl.value);
    let cleaned = raw.replace(/[^0-9]/g, '');
    let pos = inputEl.selectionStart;
    if (cleaned !== raw) {
      inputEl.value = cleaned;
      let newPos = Math.min((pos || 0) - (raw.length - cleaned.length), cleaned.length);
      try { inputEl.setSelectionRange(newPos, newPos); } catch (e) { /* noop */ }
    }
    let n = cleaned === '' ? 0 : parseInt(cleaned, 10);
    let v = this.clampReps(isFinite(n) ? n : 0);
    let ctrl = this.forms && this.forms[i] ? this.forms[i].get('reps') : null;
    if (ctrl && ctrl.value !== v) {
      // Do NOT touch inputEl.value here; the user is typing into it.
      ctrl.setValue(v, { emitEvent: false });
    }
  }

  public onRepBlur(i: number, ev: any): void {
    // On blur, normalize the visible field to the clamped integer so an
    // empty/partial entry snaps to "0" / the clamped value.
    let v = this.getReps(i);
    if (ev && ev.target) { ev.target.value = String(v); }
    this.repFocused[i] = false;
    // Persist the typed value once at commit. onRepInput deliberately does
    // not save per-keystroke (web-parity).
    this.saveFormsToReports();
  }

  public onRepFocus(i: number, ev: any): void {
    // Select-all on focus so the next keystroke replaces the value instead
    // of producing the classic "05" prefix flash.
    if (ev && ev.target && ev.target.select) {
      try { ev.target.select(); } catch (e) { /* noop */ }
    }
    this.repFocused[i] = true;
  }

  public onRepEnter(ev: any): void {
    // Enter just blurs the field. The 'input' event already committed.
    if (ev) {
      if (ev.preventDefault) { ev.preventDefault(); }
      if (ev.target && ev.target.blur) { ev.target.blur(); }
    }
  }

  // Sync the imperative <input> value when the control changes from a
  // non-typing path (+10/-10/tap/undo). Skipped while the user is in the
  // field so we never stomp on their caret.
  private syncRepInputValue(i: number): void {
    try {
      let el: any = document.getElementById('xp-rep-input-' + i);
      if (!el) { return; }
      if (document.activeElement === el) { return; }
      el.value = String(this.getReps(i));
    } catch (e) { /* noop */ }
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-measurement/xp-report-measurement.ts